<div class="flex flex-row w-full justify-between bg-white border rounded-lg p-4 border-[#d3dce8] border-solid">
  <div class="flex flex-col w-full">
    <div class="flex justify-between">
      <p class="text-base m-0 font-bold text-[#010B18]">
        {{
          selectedLinkType == 'Payment Method'
            ? 'Linked Payment Methods'
            : selectedLinkType == 'Linked Payment Method'
            ? 'Payment Method For'
            : selectedLinkType == 'Secured By'
            ? 'Secured By'
            : selectedLinkType == 'Loans Secured'
            ? 'Loans Secured'
            : ''
        }}
        <!-- : selectedLinkType == 'Secured By'
? 'Loans Secured'
: selectedLinkType == 'Loans Secured'
? 'Secured By'
: '' -->
      </p>
    </div>
    <!-- @if (!isLinkedFileLoading) { -->
    <manage-templates
      [hub_vault_user_form_id]="currentFormId"
      [origin]="data.origin"
      [data]="unlinkedTemplate"
      [placeHolder]="'Search Templates'"
      [allowedOne]="false"
      (selectionChange)="selectConnectedUser($event)"
      [selectedTemplate]="linkedTemplate"
      [isShowFooter]="false"
      [disableSearch]="isRemoveEditSaveSharing"
      [templateConfigurationList]="is_Group ? group_templateConfigurationList : templateConfigurationList"
      [isInputFullWidth]="true"
    ></manage-templates>
    <!-- } -->
    <div [ngClass]="{ 'overflow-content': false }">
      <div [ngClass]="{ 'max-h-[50%]': false }" style="overflow: auto">
        @if (linkedTemplate?.length > 0) {
        <linked-template-list
          (deleteTemplate)="deleteTemplate($event)"
          (viewTemplate)="viewModal($event)"
          (connectTemplateFeedData)="editFeedData($event)"
          (reConnectTemplateFeedData)="reconnect($event)"
          (linkedTemplateSelectionChange)="onLinkedTemplateSelectionChange($event)"
          [linkedTemplate]="linkedTemplate"
          [title]="'Payment Method'"
          [data]="handleData(data)"
          [hideTitle]="selectedLinkType == 'Secured By' || selectedLinkType == 'Loans Secured' ? true : false"
          [hideCheckbox]="isRemoveEditSaveSharing ? true : false"
          [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
        >
        </linked-template-list>
        } @if (!isUnLinkedFileLoading && !isLinkedFileLoading && linkedTemplate?.length == 0) {
        <div class="mt-[10px]">
          <div class="app__centered-item flex-row text-center h-16 border rounded-lg border-[#d3dce8] border-solid">
            <img src="assets/images/no-file-icon.svg" class="w-6 h-6" />
            <span class="app__form--attribute--title font-semibold text-[12px] ml-2">
              No <span class="font-bold text-[#25508E]"> Templates</span> to show
            </span>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
